<ng-template #main><ng-content select="[main]"></ng-content></ng-template>
<ng-template #leftColumn><ng-content select="[leftColumn]"></ng-content></ng-template>
<ng-template #rightColumn><ng-content select="[rightColumn]"></ng-content></ng-template>

<ng-container *ngIf="!centered">
  <div class="vi-tabs-container flex flex-row justify-center items-center">
    <ng-content select="[tabs]"></ng-content>
  </div>
  <div *ngIf="fluid && !twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-initial">
      <div
        class="flex flex-{{ direction }} gap-[{{ gap }}] {{
          layoutAlign
        }} w-full min-w-full h-full min-h-full"
        [class.flex-wrap]="wrap"
      >
        <div data-at-content-main class="vi-content-box flex-[100%] max-w-[100%]">
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="fluid && twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="flex-initial">
      <div class="flex flex-row justify-center items-start">
        <div
          class="vi-content-box flex flex-row sm:flex-col gap-[{{
            gap
          }}] justify-between items-start w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]"
        >
          <div
            class="flex flex-col gap-[{{
              gap
            }}] sm:flex-[1%] sm:max-w-[1%] flex-[calc(50% - 12px)] max-w-[calc(50% - 12px)]"
          >
            <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
          </div>
          <div
            class="flex flex-col gap-[{{
              gap
            }}] sm:flex-[1%] sm:max-w-[1%] flex-[calc(50% - 12px)] max-w-[calc(50% - 12px)]"
          >
            <ng-container *ngTemplateOutlet="rightColumn"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="flex-initial">
      <div class="flex flex-row justify-center items-start">
        <div
          class="customer-invitations flex flex-row xs:flex-col justify-between items-start lt-lg:flex-[100%] lt-lg:min-w-[100%] lt-lg:max-w-[100%]"
          [ngStyle]="{ 'max-width': contentWidth, 'min-width': contentWidth, flex: contentWidth }"
        >
          <div
            data-at-content-left
            class="flex flex-col gap-[{{
              gap
            }}] flex-[496px] max-w-[496px] xs:flex-[1%] xs:max-w-[1%] lt-lg:flex-[50%] lt-lg:max-w-[50%]"
          >
            <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
          </div>
          <div
            data-at-content-right
            class="flex flex-col gap-[{{
              gap
            }}] flex-[496px] max-w-[496px] xs:flex-[1%] xs:max-w-[1%] lt-lg:flex-[50%] lt-lg:max-w-[50%]"
          >
            <ng-container *ngTemplateOutlet="rightColumn"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && !twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-initial">
      <div class="flex flex-row justify-center items-start w-full min-w-full h-full min-h-full">
        <div
          data-at-content-main
          [class.flex-wrap]="wrap"
          class="vi-content-box flex flex-{{ direction }} gap-[{{ gap }}] {{
            layoutAlign
          }} lt-lg:!flex-[100%] lt-lg:!min-w-[100%] lt-lg:!max-w-[100%]"
          [ngStyle]="{ 'max-width': contentWidth, 'min-width': contentWidth, flex: contentWidth }"
        >
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="centered">
  <div *ngIf="fluid && !twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]">
      <div
        class="flex flex-{{ direction }} gap-[{{ gap }}] {{
          layoutAlign
        }} w-full min-w-full h-full min-h-full"
        [class.flex-wrap]="wrap"
      >
        <div data-at-content-main class="vi-content-box flex-[100%] max-w-[100%]">
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fluid && !twoColumns" class="vi-content flex flex-col gap-[{{ gap }}]">
    <div class="w-full min-w-full h-full min-h-full flex-[100%] max-w-[100%]">
      <div class="flex flex-row justify-center items-start w-full min-w-full h-full min-h-full">
        <div
          data-at-content-main
          [class.flex-wrap]="wrap"
          class="vi-content-box flex flex-{{ direction }} gap-[{{ gap }}] {{
            layoutAlign
          }} lt-lg:flex-[100%] lt-lg:max-w-[100%]"
          [ngStyle]="{ 'min-width': contentWidth, flex: contentWidth }"
        >
          <ng-container *ngTemplateOutlet="main"></ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- <div
    [class.flex-wrap]="wrap"
    class="vi-content flex flex-{{ direction }} gap-[{{ gap }}] {{ layoutAlign }} w-full min-w-full h-full min-h-full"
  >
    <ng-container *ngTemplateOutlet="main"></ng-container>
  </div> -->
</ng-container>
